export default (_ctx, inject) => {
  let color
  if (process.client) color = new Worker('/workers/getColor.js')
  inject('worker', { color })
}
